import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDia: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="dia"><path d="M12 2.70358C12.2518 2.70355 12.5058 2.71207 12.7613 2.72964C18.0971 3.09701 22.4035 7.44413 22.7306 12.7839C22.8815 15.2705 22.1449 17.5893 20.7928 19.5992C20.3771 20.2173 19.554 20.3586 18.8712 20.0609C16.7569 19.139 14.3784 18.4064 12 18.4377C9.62158 18.4064 7.24311 19.1391 5.12881 20.0609C4.44602 20.3586 3.62294 20.2173 3.20718 19.5992C1.85505 17.5893 1.1185 15.2705 1.26942 12.7839C1.59648 7.4441 5.90288 3.09695 11.2387 2.72964C11.4942 2.71207 11.7482 2.70355 12 2.70358Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDia;
